import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RecipesSearchComponent } from './recipes-search.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [RecipesSearchComponent],
  exports: [
    RecipesSearchComponent
  ]
})
export class RecipesSearchModule { }



// WEBPACK FOOTER //
// ./src/app/recipes-search/recipes-search.module.ts